import React from 'react';
import { useTranslation } from "react-i18next";
import StatusColor from '../../common/Utils/StatusColor/StatusColor';
import { formatEtaTime, isDelayedTimeCheck } from '../../common/Utils/etaTime/etaTime';
import { useSelector } from 'react-redux';
import { configurationCompanySetting, statusEnum } from '../../common/enums';
import Icon from '../Icon/Icon';
import { Stack, Typography } from '@mui/material';

const ETA = ({ orderStatus, arrivalTime, estimatedArrivalTime, exceptedArrivalTime, exceptedExitTime, siteLocalTime, isDelayed }) => {
    const { t } = useTranslation();

    const isOnMyWay = orderStatus === statusEnum["On my way"];
    const isEnRouteOrPickingUp = orderStatus === statusEnum["En-Route"] || orderStatus === statusEnum["Picking Up"];
    const companySettings = useSelector(state => state.authState.userData?.data?.company_settings);
    const enRouteEtaSetting = companySettings?.some(setting => setting.module_name === configurationCompanySetting.EnRouteEtaVisible);

    let etaText = "";
    let iconString = "fa-clock";

    if (arrivalTime) {
        etaText = `${t("OrdersTab.driverArrived")} : ${formatEtaTime(arrivalTime, siteLocalTime)}`;
        iconString = "fa-check";
    } else if (isDelayed || isDelayedTimeCheck(isOnMyWay, estimatedArrivalTime, exceptedExitTime, siteLocalTime)) {
        etaText = `${t("Dashboard.delayed")}`;
    } else if (enRouteEtaSetting && isEnRouteOrPickingUp && exceptedArrivalTime && exceptedExitTime) {
        etaText = `${t("OrdersTab.eta")} : ${formatEtaTime(exceptedArrivalTime, siteLocalTime)} - ${formatEtaTime(exceptedExitTime, exceptedArrivalTime)}`;
    } else if (isOnMyWay && estimatedArrivalTime) {
        etaText = `${t("OrdersTab.eta")} : ${formatEtaTime(estimatedArrivalTime, siteLocalTime)}`;
    }

    return (
        etaText && <Stack direction="row" spacing={1} alignItems="center">
            <Icon icon={iconString} color={StatusColor(orderStatus).text} />
            <Typography color={StatusColor(orderStatus).text} >
                {etaText}
            </Typography>
        </Stack>
    )
}

export default ETA;